import { EXPRESS_API } from 'configs/api/expressApi';
import { useQuery } from 'react-query';
import { videoAttributesKeys } from './videoAttributesKeys';
import { VideoAttributeValue } from '../types';
import { useAuth } from 'lib/context';
import { checkIfFreemium, checkIfProUser } from 'lib/utils/functions';

export const getVideoAttributes = async (videoId: number) => {
  const { data } = await EXPRESS_API.get(`/videos/${videoId}/video-attributes`);
  return data as VideoAttributeValue[];
};

export const useGetVideoAttributes = (videoId: number) => {
  const { userData } = useAuth();
  const isFreemium = checkIfFreemium(userData);
  const isProUser = checkIfProUser(userData);

  return useQuery(
    videoAttributesKeys.detail(videoId),
    () => getVideoAttributes(videoId),
    {
      enabled: !isFreemium && !isProUser,
    }
  );
};
